import { Component, ChangeDetectionStrategy, HostBinding, AfterViewInit, inject } from '@angular/core';
import { OneTrustService } from '../../../app/providers/one-trust.service';

@Component({
  selector: 'button[app-one-trust-button]',
  templateUrl: './one-trust-button.component.html',
  styleUrls: ['./one-trust-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class OneTrustButtonComponent implements AfterViewInit {

  @HostBinding('id') private readonly idProperty = 'ot-sdk-btn';
  @HostBinding('class') private readonly classProperty = 'ot-sdk-show-settings';
  @HostBinding('attr.type') private readonly typeAttribute = 'button';

  private oneTrustService = inject(OneTrustService);

  public ngAfterViewInit(): void {
    this.oneTrustService.renderButtonAndList();
  }

}
